<template>
    <div class="position-relative">
        <input @input="autocomplete"
               @keydown.up.prevent="moveUp"
               @keydown.down.prevent="moveDown"
               @keydown.enter.prevent="handleEnter"
               :id="id"
               :name="name"
               type="text"
               class="form-control input input-text"
               :placeholder="placeholder"
               :aria-describedby="placeholder"
               v-model="search"
               autocomplete="off">
        <ul v-show="results.length > 0" class="ps-0 bg-white rounded-0 position-absolute start-0 end-0 z-3">
            <li v-for="(result, index) in results"
                :key="result.id"
                @click.prevent="add(result)"
                v-html="formatResult(result)"
                :class="{ 'highlighted': index === selectedIndex }"
                class="px-2 list-unstyled where-result cursor-pointer"></li>
        </ul>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        oldValue: {
            type: String,
            required: false
        },
        type: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        reset: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            abortController: null,
            search: '',
            results: [],
            selectedIndex: -1,
            itemSelected: false
        }
    },

    watch: {
        reset: function (newVal) {
            if (newVal && newVal === true) {
                this.results = [];
            }
        },
        oldValue: function (newVal) {
            this.search = newVal;
        }
    },

    mounted() {
        if (this.oldValue) {
            this.search = this.oldValue;
        }
    },

    methods: {
        add(result) {
            this.search = this.formatResult(result);
            this.results = [];
            this.selectedIndex = -1;
            this.itemSelected = true;
        },
        autocomplete() {
            if (this.abortController) {
                this.abortController.abort();
            }
            this.abortController = new AbortController();

            if (this.search.length > 1 && /\s$/.test(this.search) === false) {
                this.results = [];
                axios.get('/api/v1/autocompletions/' + this.type, {
                    params: {
                        q: this.search
                    },
                    signal: this.abortController.signal,
                }).then(response => {
                    this.results = response.data;
                    if (this.results.length > 0) {
                        this.selectedIndex = 0;  // Sélectionner le premier élément
                    }
                }).catch(err => {
                    console.error(err);
                });
            }
        },
        formatResult(result) {
            if (result.postal_code) {
                return result.name.charAt(0).toUpperCase() + result.name.slice(1) + ' ' + result.postal_code;
            }
            return result.name.charAt(0).toUpperCase() + result.name.slice(1);
        },
        moveUp() {
            if (this.selectedIndex > 0) {
                this.selectedIndex--;
            } else {
                this.selectedIndex = this.results.length - 1;
            }
        },
        moveDown() {
            if (this.selectedIndex < this.results.length - 1) {
                this.selectedIndex++;
            } else {
                this.selectedIndex = 0;
            }
        },
        selectItem() {
            if (this.selectedIndex >= 0 && this.selectedIndex < this.results.length) {
                this.add(this.results[this.selectedIndex]);
            }
        },
        handleEnter() {
            if (this.itemSelected) {
                this.submitForm();
            } else {
                this.selectItem();
            }
        },
        submitForm() {
            const form = this.$el.closest('form');
            if (form) {
                form.submit();
            }
        }
    }
};
</script>

<style scoped>
.search-results {
    position: absolute;
    width: 100%;
    max-height: 300px;
    overflow: auto;
    z-index: 1000;
    background-color: white;
    color: black;
    border: 1px solid gray;
    cursor: pointer;
}

.result-list {
    padding-left: 5px;
    padding-right: 5px;
}

.highlighted {
    background-color: #ddd;
}
</style>
